import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, concat, Observable, of, Subject } from 'rxjs';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  switchMap,
  tap,
} from 'rxjs/operators';
import Swal from 'sweetalert2';

import { ClientService } from '@app/core/client/services/client.service';
import { RfqClientService, RfqService, RFQ } from '@app/core/quotes';

@Component({
  selector: 'cnc-rfq-clients-popup-form',
  templateUrl: './rfq-clients-popup-form.component.html',
  styleUrls: ['./rfq-clients-popup-form.component.scss'],
})
export class RfqClientsPopupFormComponent implements OnInit {
  formData :UntypedFormGroup;
  pageTitle :string = 'Add Client';
  loading :boolean;
  submitted :boolean;

  @Input() rfq :any;
  @Input() rfqId :number;

  client$ :any;
  clientLoading = false;
  clientInput$ = new Subject<string>();

  constructor(
    private fb :UntypedFormBuilder,
    public activeModal :NgbActiveModal,
    private toastr :ToastrService,
    private cd :ChangeDetectorRef,
    private clientSvc :ClientService,
    private rfqClientSvc :RfqClientService,
  ) {}

  ngOnInit() {
    this.formData = this.fb.group({
      line_items: this.fb.array([]),
    });

    this.loadClient();
    // this.rfq$.subscribe((data) => {
    //     this._kitRfqs.next(data);
    // })
  }

  private loadClient() {
    this.client$ = concat(
      this.clientSvc.search('a'), // default items
      this.clientInput$.pipe(
        distinctUntilChanged(),
        tap(() => (this.clientLoading = true)),
        switchMap((term) =>
          this.clientSvc.search(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => (this.clientLoading = false)),
          ),
        ),
      ),
    );
  }

  save() {
    this.submitted = true;
    if (this.formData.invalid) {
      Swal.fire({
        title: 'Form Error!',
        text: 'Please fill all the required fields.',
        type: 'error',
        confirmButtonText: 'Back to Form',
      });

      return;
    }

    this.loading = true;

    const fd :any = Object.assign({}, this.formData.value);
    const lineItems = fd.line_items.map((e) => e.item.id);

    this.rfqClientSvc.store({ rfq_id: this.rfqId, clients: lineItems }).subscribe(
      (resp) => {
        this.toastr.success('New client added');
        this.loading = false;
        this.activeModal.dismiss();
      },
      (error) => {
        this.loading = false;
        this.toastr.error(
          'Error creating rfq client. Please try again later or contact support.',
        );
        this.cd.detectChanges();
      },
    );
  }

  addItem(item ?:any) {
    const lineItems :UntypedFormArray = this.formData.get(
      'line_items',
    ) as UntypedFormArray;

    lineItems.push(
      this.fb.group({
        item: {
          id: undefined,
        },
      }),
    );
  }

  removeItem(idx :any) {
    const lineItems :UntypedFormArray = this.formData.get(
      'line_items',
    ) as UntypedFormArray;
    lineItems.removeAt(idx);
  }
}
